import {connect} from "react-redux";
import FeedbackModal from '../../components/Video/FeedbackModal';
import * as VideoActions from "../../store/actions/videoActions";


const mapStateToProps = (state) => ({
    ...state.auth,
    ...state.video
});

const mapDispatchToProps = (dispatch) => ({
    sendFeedback: (feedback, token) => {
        dispatch(VideoActions.sendFeedback(feedback, token));
    }

});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FeedbackModal);



// WEBPACK FOOTER //
// ./src/containers/Video/FeedbackContainer.js